import FacebookLogin from "@greatsumini/react-facebook-login";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const API_BASE = "https://edunet.kmechengineering.com/root-engine1/api";

const AuthPage = () => {

  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  /* ================= RESPONSIVE ================= */

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  /* ================= NAVBAR HIDE / TOP SHOW ONLY ================= */

  useEffect(() => {

    const navbar = document.querySelector(".navbar");

    const handleScroll = () => {

      const currentScroll = window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {
        navbar.style.transform = "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      }
      else {
        navbar.style.transform = "translateX(-50%) translateY(-130%)";
        navbar.style.opacity = "0";
      }
    };

    if (navbar) {
      navbar.style.position = "fixed";
      navbar.style.top = "15px";
      navbar.style.left = "50%";
      navbar.style.width = "90%";
      navbar.style.maxWidth = "1100px";
      navbar.style.transform = "translateX(-50%)";
      navbar.style.zIndex = "9999";
      navbar.style.transition = "all 0.35s ease";
    }

    window.addEventListener("scroll", handleScroll);

    return () => {

      window.removeEventListener("scroll", handleScroll);

      if (navbar) {
        navbar.style.transform = "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      }

    };

  }, []);


  /* ================= SYNC MCQ ================= */

  const syncPendingMCQ = async () => {

    const pending = localStorage.getItem("pending_mcq");
    const user = JSON.parse(localStorage.getItem("user"));

    if (!pending || !user?.id) return;

    const data = JSON.parse(pending);

    try {

      const res = await fetch(`${API_BASE}/mcq-save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          ...data,
          user_id: user.id,
          guest_token: localStorage.getItem("guest_token"),
          type: "free"
        })
      });

      await res.json();

      localStorage.removeItem("pending_mcq");

    } catch (err) {
      console.log("Sync error ❌", err);
    }
  };


  /* ================= REDIRECT ================= */

  const handleRedirect = async () => {

    await syncPendingMCQ();

    /* ================= NEW EDUNET FLOW ================= */

    const newEdunetFlow = sessionStorage.getItem("edunet_new_login_flow");

    if (newEdunetFlow === "true") {

      sessionStorage.removeItem("edunet_new_login_flow");

      navigate("/education-type", {
        replace: true
      });

      return;
    }


    /* ================= EXISTING FLOW ================= */

    const redirect = localStorage.getItem("redirect_after_login");

    console.log("redirect_after_login =", redirect);
    console.log("Before Navigate =", window.location.pathname);

    if (redirect) {

      localStorage.removeItem("redirect_after_login");

      navigate(redirect, {
        replace: true
      });

      return;
    }


    /* ================= DEFAULT EXISTING LOGIN ================= */

    console.log("Navigate => /profile");

    navigate("/profile", {
      replace: true
    });

  };


  /* ================= AUTO LOGIN ================= */

  useEffect(() => {

    const user = JSON.parse(localStorage.getItem("user"));

    if (user && user.id) {
      handleRedirect();
    }

  }, []);


  /* ================= SAVE USER ================= */

  const saveUserToDB = async (userData) => {

    try {

      const res = await fetch(`${API_BASE}/app-users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(userData)
      });

      const data = await res.json();

      return data.user || null;

    } catch {
      return null;
    }
  };


  /* ================= GOOGLE LOGIN ================= */

  const googleLogin = useGoogleLogin({

    onSuccess: async (tokenResponse) => {

      const res = await fetch(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`
          }
        }
      );

      const profile = await res.json();

      const userData = {
        full_name: profile.name,
        email: profile.email,
        avatar: profile.picture,
        provider: "Google",
        provider_id: profile.sub
      };

      const guestToken = localStorage.getItem("guest_token");

      const dbUser = await saveUserToDB({
        ...userData,
        guest_token: guestToken
      });

      const user = {
        ...userData,
        id: dbUser?.id
      };

      localStorage.setItem("user", JSON.stringify(user));

      await handleRedirect();
    }

  });


  /* ================= FACEBOOK LOGIN ================= */

  const handleFacebookSuccess = (response) => {

    const token =
      response.accessToken ||
      response.authResponse?.accessToken;

    fetch(
      `https://graph.facebook.com/me?fields=id,name,email,picture.type(large)&access_token=${token}`
    )
      .then((res) => res.json())
      .then(async (profile) => {

        const userData = {
          full_name: profile.name,
          email: profile.email,
          avatar: profile.picture?.data?.url,
          provider: "Facebook",
          provider_id: profile.id
        };

        const guestToken = localStorage.getItem("guest_token");

        const dbUser = await saveUserToDB({
          ...userData,
          guest_token: guestToken
        });

        const user = {
          ...userData,
          id: dbUser?.id
        };

        localStorage.setItem("user", JSON.stringify(user));

        await handleRedirect();

      });

  };


  /* ================= UI ================= */

  return (
    <div style={styles.container}>

      {/* MOBILE LOGO */}

      {isMobile && (
        <div style={styles.centerLogo}>
          <img
            src="/logo2.png"
            style={styles.logoSmall}
            alt=""
          />
        </div>
      )}

      {/* DESKTOP LOGO */}

      {!isMobile && (
        <div style={styles.left}>
          <img
            src="/logo2.png"
            alt="Logo"
            style={styles.logo}
          />
        </div>
      )}

      <div style={styles.right}>

        <div
          style={{
            ...styles.card,
            marginTop: isMobile ? "140px" : "0px"
          }}
        >

          <h2 style={styles.title}>
            Create an account
          </h2>

          <button
            onClick={googleLogin}
            style={styles.googleBtn}
          >

            <img
              src="https://www.svgrepo.com/show/475656/google-color.svg"
              style={styles.icon}
              alt=""
            />

            Continue with Google

          </button>

          <FacebookLogin
            appId="1353760463435499"
            onSuccess={handleFacebookSuccess}
            render={(props) => (
              <button
                onClick={props.onClick}
                style={styles.fbBtn}
              >

                <img
                  src="https://www.svgrepo.com/show/448224/facebook.svg"
                  style={styles.icon}
                  alt=""
                />

                Continue with Facebook

              </button>
            )}
          />

          <p style={styles.text}>
            Already registered?{" "}
            <span style={styles.link}>
              Sign in
            </span>
          </p>

        </div>

      </div>

    </div>
  );
};

export default AuthPage;


/* ================= STYLES ================= */

const styles = {

  container: {
    position: "relative",
    display: "flex",
    height: "100vh",
    background: "#020617"
  },

  centerLogo: {
    position: "absolute",
    top: "120px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 10
  },

  logoSmall: {
    width: "100px",
    height: "100px",
    borderRadius: "20px",
    boxShadow: "0 15px 30px rgba(0,0,0,0.7)"
  },

  left: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  logo: {
    width: "280px"
  },

  right: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  card: {
    width: "380px",
    maxWidth: "90%",
    background: "#111827",
    padding: "30px",
    borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.5)"
  },

  title: {
    color: "#fff",
    textAlign: "center",
    marginBottom: "20px"
  },

  googleBtn: {
    width: "100%",
    height: "45px",
    marginBottom: "12px",
    borderRadius: "10px",
    border: "1px solid #334155",
    background: "#020617",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer"
  },

  fbBtn: {
    width: "100%",
    height: "45px",
    borderRadius: "10px",
    background: "#1877f2",
    color: "#fff",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "10px",
    cursor: "pointer"
  },

  icon: {
    width: "20px",
    marginRight: "10px"
  },

  text: {
    textAlign: "center",
    color: "#94a3b8",
    marginTop: "15px"
  },

  link: {
    color: "#60a5fa",
    cursor: "pointer"
  }

};

